<template>
    <div class="w-full flex justify-center">
        <div class="lg:w-3/5 p-4 flex flex-col justify-center items-center bg-grey-lightest">
            <div class="shadow w-full bg-blue-dark flex flex-col justify-center items-center py-2 rounded-t">
                <h3 v-responsive.md.lg.xl class="text-grey-lightest bg-blue-darker py-2 px-4 rounded-full my-2">
                    We raden je aan ons op te bellen!
                </h3>
                <ContactInformation :contents="contents"></ContactInformation>
            </div>
            <div class="shadow w-full bg-blue flex flex-col justify-center items-center py-2 rounded-b">
                <ContactForm class="my-4" :contents="contents"></ContactForm>
            </div>
            <div class="shadow w-full bg-blue-dark flex flex-col justify-center items-center py-2 rounded-b">
                <div class="lg:flex">
                    <div class="h-48 lg:h-auto lg:w-48 flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden"
                         style="background-image: url('/img/contact1.jpg')"
                         title="E. Budding Vloerverwarmingen">
                    </div>
                    <div class="border-r border-b border-l border-grey-light lg:border-l-0 lg:border-t lg:border-grey-light bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                        <div class="mb-8 ">
                            <div class="text-black font-bold text-xl mb-2">Bedrijfsinformatie</div>
                            <div class="text-grey-darkest" v-for="item in contents.pages.contact.content.block2" v-bind:key="item.value">
                                <span class="text-grey-dark">{{item.key}}</span>
                                {{item.value}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ContactForm from "./ContactForm"
    import ContactInformation from "./ContactInformation"

    export default {
        name: "ContactComponent",
        components: {ContactInformation, ContactForm},
        props: ['contents']
    }
</script>
